import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useData, useTexts } from '../data';
import tracker from '../analytics/tracker';

const CorrectionButton = ({ donors, className = 'btn btn-info w-100' }) => {
  const { time } = useData();
  const TEXTS = useTexts();

  if (!donors || donors.length === 0 || time.currentStatus >= 3) {
    return null;
  }

  const firstDonor = donors.length > 1 ? donors[1] : donors[0];

  return (
    <Link
      className={className}
      to={`/cr/${firstDonor.donorId}`}
      onClick={() => tracker.correctionClick(firstDonor.donorId)}
      state={{
        donorNameTamil: firstDonor.donorNameTamil || '',
        phone: firstDonor.phone || '',
        fullAddress: firstDonor.fullAddress || '',
        pincode: firstDonor.pincode || '',
        products: firstDonor.donatedProduct || '',
      }}
    >
      {TEXTS.CORRECTION_NEEDED}
    </Link>
  );
};

CorrectionButton.propTypes = {
  donors: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default CorrectionButton;
